import React from 'react';
import ReactDOM from 'react-dom';
import { addDays, format, parse } from 'date-fns';

class Result extends React.Component {
  constructor(props) {
    super(props);
  }
  formatCurrency(pence) {
    var pounds = pence / 100;
    return pounds.toFixed(2);

  }
  render() {
    var model = this.props.model;

    var classNames = "mb-2 border rounded audax-award-color audax-award-" + model.NominalDistance;
    var eventDateStr = null;
    if(model.EventDate){
      var date = parse(model.EventDate,"yyyy/MM/dd", new Date());
      //eventDateStr = model.EventType === "C" ? format(date,"EEE dd/MM/yyyy") : "";
      eventDateStr = format(date,"EEE dd/MM/yyyy");
    }
    return (
      <article className={classNames}>

        <div className="d-flex justify-content-between" style={{ height: "100%" }}>
          <div style={{ width: "100%" }} >
            <div className={" audax-award-color-header audax-award-header-" + model.NominalDistance} style={{ float: "left", height: "100%", paddingRight: "6px" }}>
            </div>
            <div>
              <h5 className="ms-3 mb-0">
                {/* <a className="u-link-v5 g-color-gray-dark-v1 g-color-primary--hover" href={model.Url}>{eventDateStr? " "+ eventDateStr +" -":""} {model.Name} ({model.Category})</a> */}
                <span>{eventDateStr? eventDateStr : ""} <a className="u-link-v5 g-color-gray-dark-v1 g-color-primary--hover" href={model.Url}>{model.Name} ({model.Category})</a></span>
              </h5>

              <ul className="list-inline ms-3 mb-0">
                {model.StartTime && (
                  <li className="list-inline-item g-mr-15 mobile-mini-list">
                    <span className="u-link-v5 ">{model.StartTime}</span>
                  </li>
                )}
                <li className="list-inline-item g-mr-15 mobile-mini-list">
                  <span className="u-link-v5 ">{model.OrganizerName}</span>
                </li>
                {model.HasGpx && (
                  <li className="list-inline-item g-mr-15 mobile-mini-list" title="Proof of passage by GPS allowed" >
                    <img src="/images/gpx.svg" style={{ height: "20px" }} />
                  </li>
                )}
                {model.HasEbrevet && (
                  <li className="list-inline-item g-mr-15 mobile-mini-list" title="Proof of passage by eBrevet app allowed">
                    <img src="/images/smartphone.svg" style={{ height: "20px" }} />
                  </li>
                )}
                {model.Receipts && (
                  <li className="list-inline-item g-mr-15 mobile-mini-list" title="Proof of passage by paper receipts allowed" >
                    <img src="/images/bill.svg" style={{ height: "20px" }} />
                  </li>
                )}



                <li className="list-inline-item g-mr-15" title="Distance" >
                  <img src="/images/distance.svg" style={{ height: "20px" }} />
                  {model.NominalDistance}km
                </li>

                <li className="list-inline-item g-mr-15" title="Entry Fee">
                  <img src="/images/price.svg" style={{ height: "20px" }} />  £{this.formatCurrency(model.OnlineFee)}
                </li>

                <li className="list-inline-item g-mr-15" title="Start location">
                  <img src="/images/location.svg" style={{ height: "20px" }} />  {model.StartLocation}
                </li>
                <li className="list-inline-item g-mr-15" title="AAA Points">
                  <img src="/images/mountain.svg" style={{ height: "20px" }} /> {model.AAAPoints} AAA
                </li>

              </ul>
                  
              {model.RiddenCount > 0 && (
                <div className="g-color-gray-dark-v5 ms-3">Completed by {model.RiddenCount?.toLocaleString()} riders in the last year</div>
              )}
            </div>
          </div>
          <a className="btn btn-sm auk-btn-secondary g-font-size-16 g-px-15 text-white search-next-button" href={model.Url}>
            <div className="search-next-button-inner">
              <i className="fa fa-arrow-right" aria-hidden="true"></i>


            </div>

          </a>
        </div>
      </article>

    );
  }
}
export default Result;

